package link.erpango.quip.data

import app.cash.sqldelight.db.SqlDriver
import link.erpango.quip.QuipConstants
import link.erpango.quip.data.db.DbDataSource
import link.erpango.quip.data.firebase.FirebaseDataSource
import link.erpango.quip.data.firebase.IFirebaseClient
import link.erpango.quip.data.remote.ApiUrlResolver
import link.erpango.quip.data.remote.HttpClientFactory
import link.erpango.quip.data.remote.ServerApiClient
import link.erpango.quip.data.remote.ktor.HttpClientManager
import link.erpango.quip.data.remote.repository.RemoteDataSource
import link.erpango.quip.db.QuipDb
import link.erpango.quip.utils.DatetimeUtils
import app.cash.sqldelight.async.coroutines.awaitAsOneOrNull
import app.cash.sqldelight.async.coroutines.awaitAsList

import app.cash.sqldelight.ColumnAdapter
import linkerpangoquipdb.Vehicle

open class DataSource(
    private val _apiUrl: String,
    private val _sqlDriver: SqlDriver,
    private val _firebase: IFirebaseClient,
    private val _appVersion: String,
    private val _driverManagesSchema: Boolean = false
): IDataSource {


    private var _db: DbDataSource? = null
    override val db: DbDataSource by lazy {
        _db ?: throw IllegalStateException("DataSource not initialized")
    }


    suspend fun init() {

        val quipDb = QuipDb(
            driver = _sqlDriver,
            vehicleAdapter = Vehicle.Adapter(
                cylinder_countAdapter = object : ColumnAdapter<Int, Long> {
                    override fun decode(databaseValue: Long): Int = databaseValue.toInt()
                    override fun encode(value: Int): Long = value.toLong()
                }
            )
        )

        var schemaExists = false
        val lastMigrationVersion = try {
            val res = quipDb.commonValuesQueries.selectValue(
                QuipConstants.CommonValues.Generic.lastDatabaseMigrationVersion
            ).awaitAsOneOrNull()?.toLong()
            schemaExists = true
            res
        } catch (e: Throwable) {
            null
        }
        val currentInstanceVersionCode: Long = QuipDb.Schema.version.toLong()

        if (lastMigrationVersion == null) {
            if (!schemaExists && !_driverManagesSchema) {
                QuipDb.Schema.create(_sqlDriver).await()
            }
            val versionStr = QuipDb.Schema.version.toString()
            quipDb.commonValuesQueries.insertValue(
                QuipConstants.CommonValues.Generic.lastDatabaseMigrationVersion,
                versionStr,
                DatetimeUtils.currentTimeMillis()
            )
        } else if (lastMigrationVersion < currentInstanceVersionCode) {
            if (!_driverManagesSchema) {
                QuipDb.Schema.migrate(_sqlDriver, lastMigrationVersion, currentInstanceVersionCode).await()
            }
            quipDb.commonValuesQueries.selectValue(QuipConstants.CommonValues.Generic.lastDatabaseMigrationVersion)
                .awaitAsOneOrNull()?.let {
                quipDb.commonValuesQueries.updateValue(
                    QuipDb.Schema.version.toString(),
                    DatetimeUtils.currentTimeMillis(),
                    QuipConstants.CommonValues.Generic.lastDatabaseMigrationVersion
                )
            } ?: run {
                quipDb.commonValuesQueries.insertValue(
                    QuipConstants.CommonValues.Generic.lastDatabaseMigrationVersion,
                    QuipDb.Schema.version.toString(),
                    DatetimeUtils.currentTimeMillis()
                )
            }
        }

        quipDb.commonValuesQueries.selectValue(QuipConstants.CommonValues.SystemInfo.appVersionCode)
            .awaitAsOneOrNull()?.let {
            quipDb.commonValuesQueries.updateValue(
                _appVersion,
                DatetimeUtils.currentTimeMillis(),
                QuipConstants.CommonValues.SystemInfo.appVersionCode
            )
        } ?: run {
            quipDb.commonValuesQueries.insertValue(
                QuipConstants.CommonValues.SystemInfo.appVersionCode,
                _appVersion,
                DatetimeUtils.currentTimeMillis()
            )
        }
        _db = DbDataSource(quipDb)
        HttpClientManager.dataSource = this
    }

    override val firebase = FirebaseDataSource(_firebase)
    override val remote = RemoteDataSource(createApi(_apiUrl))

    private fun createApi(url: String): ServerApiClient {
        val urlResolver = ApiUrlResolver(url)
        val client = HttpClientFactory().createClient(HttpClientManager)
        return ServerApiClient(this, urlResolver, client)
    }
}